import React from "react";
import searchIcon from "../../../../assets/forhomepage/search_icon.svg";
import closeIcon from "../../../../assets/forhomepage/close_icon.svg";

const StaffSearchbar = (props) => {
  const { inputText, clearData, onSubmit, placeholder,onChange } = props;
  return (
    <div className="mr-2 search-wrapper">
      <div className="input-holder">
        <input
          type="text"
          className="search-input"
          onChange={onChange} //(e) => onSubmit({ search_string: e.target.value })
          value={inputText}
          placeholder={placeholder}
        />{" "}
        <div className="search-icon">
          <img src={searchIcon} />
        </div>
        {inputText !== "" && (
          <div className="close_serch">
            <img src={closeIcon} onClick={clearData} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffSearchbar;
